export default __webpack_public_path__ + "static/media/hero-agileMedium.c589b58d.jpg";